import { Component } from '@inter-ikea-core/core';
import { HandleType } from '../../types';

/**
 * Added to doors/drawers to hold which handle type they support
 */
export default class AllowedHandleTypeComponent implements Component {
  static id = 2036;
  typeId = AllowedHandleTypeComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;
  handleTypes: HandleType[];

  constructor(handleTypes: HandleType[]) {
    this.handleTypes = handleTypes;
  }

  eq() {
    return false;
  }
}
